import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SPColor } from "../../constants/color";
import { SelectItem } from "../../types/global";
import { SchoolLeader } from "../../types/record";
import Loading from "../Loading/Loading";
import SPSelect from "../SPSelect/SPSelect";
import LeaderBoard from "./LeaderBoard";

type WeekType = {
  tag: string;
  name: string;
};

type GradeLeaderProp = {
  gradeList: SelectItem[];
  weeks: WeekType[];
  competitionIframeUrl: string;
  cityId: string | null;
  subject: string | null;
};

export default function GradeLeader({
  gradeList,
  weeks,
  competitionIframeUrl,

  cityId,
  subject,
}: GradeLeaderProp) {
  const [list, setList] = useState<SchoolLeader[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [grade, setGrade] = useState<number | null>(null);

  const [weekTag, setWeekTag] = useState("");

  const fetchGradeInfo = async (grade: number, weekTag: string) => {
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_API_URL}/api/school-leader/${grade}?week=${weekTag}&cityId=${cityId}&subject=${subject}`
    )
      .then((response) => response.json())
      .then((data) => {
        const list = JSON.parse(data.data);
        setList(
          list.sort((a: SchoolLeader, b: SchoolLeader) =>
            a.place > b.place ? 1 : -1
          )
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    if (weeks && weeks.length > 0 && gradeList && gradeList.length > 0) {
      setWeekTag(weeks[0].tag);
      setGrade(Number(gradeList[0].value));
    }
  }, []);

  useEffect(() => {
    if (grade && weekTag) {
      fetchGradeInfo(grade, weekTag);
    } else {
      setList([]);
    }
  }, [grade, weekTag]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box sx={{ textAlign: "center", maxWidth: "md", margin: "auto" }}>
      <Box
        sx={{
          marginTop: 1,
          width: "100%",
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",

          flexDirection: { sm: "row", xs: "column-reverse" },
        }}
      >
        <Box flex={1}>
          {weeks && (
            <SPSelect
              items={weeks?.map((item) => ({
                label: item.name,
                value: item.tag,
              }))}
              onChange={(e: number | string) => setWeekTag(e.toString())}
              defaultValue={weekTag}
              bgColor={SPColor.WHITE}
              sx={{
                minWidth: { xl: "150px", xs: "25%" },
                "& .MuiOutlinedInput-notchedOutline, & .MuiSelect-outlined, & .MuiSelect-select":
                  {
                    padding: "4px 28px 4px 16px",
                    borderColor: SPColor.GREEN + " !important",
                    borderWidth: "2px !important",
                    border: "solid",
                  },
              }}
              placeholder="בחר תקופה"
              name={"school"}
            />
          )}
        </Box>

        <Box
          flex={1}
          sx={{
            mt: { sm: 0, xs: 2 },
          }}
        >
          <SPSelect
            items={gradeList}
            onChange={(e: string | number) => setGrade(+e)}
            defaultValue={grade || ""}
            bgColor={SPColor.WHITE}
            sx={{
              // borderColor: "black",
              minWidth: { xl: "150px", xs: "25%" },
              "& .MuiOutlinedInput-notchedOutline, & .MuiSelect-outlined, & .MuiSelect-select":
                {
                  padding: "4px 28px 4px 16px",
                  borderColor: SPColor.GREEN + " !important",
                  borderWidth: "2px !important",
                  border: "solid",
                },
            }}
            placeholder="בחר את סוג התחרות"
            name={"grade"}
          />
        </Box>
      </Box>
      <Box>
        {/* table header */}
        {grade && weekTag && (
          <Box
            sx={{
              mt: 1,
              borderRadius: "5px",
              backgroundColor: SPColor.SYSTEM1,
              display: "flex",
              color: "white",

              py: { sm: 0, xs: 1 },
            }}
          >
            <Box
              sx={{
                width: "140px",
                display: "flex",
                alignItems: "center",
                justifyContent: {
                  sm: "center",
                  xs: "space-around",
                },
                flexDirection: {
                  sm: "row",
                  xs: "column",
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                className="title-text"
              >
                כוכבים
              </Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  display: { sm: "none", xs: "flex" },
                }}
                className="title-text"
              >
                שעות
              </Typography>
            </Box>
            <Box sx={{ flex: 1, px: 1, display: { sm: "flex", xs: "none" } }}>
              <Box
                sx={{
                  display: "flex",
                  height: "50px",
                }}
              >
                <Box
                  sx={{
                    width: "100px",
                    p: "2px",
                    margin: "5px",
                  }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    שעות
                  </Typography>
                </Box>
                <Box
                  sx={{ width: "100px", p: "2px", margin: "5px" }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    פעילים
                  </Typography>
                </Box>
                <Box
                  sx={{ width: "100px", p: "2px", margin: "5px" }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    תלמידים
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ flex: 1 }} className="title-text">
                <Typography sx={{ fontWeight: "bold" }}>
                  {grade === 100 ? "בית ספר" : " כיתה / קבוצה"}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                flex: 1,
                px: 1,
                display: { sm: "none", xs: "flex" },
                flexDirection: "column",
                justifyContent: "space-around",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{ fontWeight: "bold", textAlign: "right", pr: 2 }}
                >
                  {grade === 100 ? "בית ספר" : " כיתה / קבוצה"}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  // height: "50px",
                }}
              >
                <Box
                  sx={{ width: "100px", px: "2px", mx: "5px" }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    פעילים
                  </Typography>
                </Box>
                <Box
                  sx={{ width: "100px", px: "2px", mx: "5px" }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    תלמידים
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        )}

        {/* table header end */}

        {list.map((item: SchoolLeader) => (
          <LeaderBoard item={item} key={item.id} type="grade" />
        ))}
      </Box>
      {/* {(!grade || !weekTag) && (
        <Box sx={{ marginTop: 3, textAlign: "justify" }}>
          <iframe
            src={competitionIframeUrl}
            style={{ width: "100%", minHeight: "60vh", border: "none" }}
          />
        </Box>
      )} */}

      {/* {(!grade || !weekTag) && (
        <Box sx={{ direction: "RTL", marginTop: 3, textAlign: "justify" }}>
          <Typography>
            במסגרת פרויקט ״בודור מדברת עברית״ מתקיימת תחרות עירונית של עברית
            דבורה בין כיתות ובין בתי הספר בעיר. מטרת התחרות היא לעודד תרגול
            דיבור בעברית בעזרת סימולטור השיחה,להגביר את המודעות וחשיבות הנושא
            ולעודד עזרה הדדית בין התלמידים. הציון הכיתתי משקףאת כמות ההשקעה
            והתרגול של כל תלמידי הכיתה ומתחשב ברמת הדיבור הכיתתית.
          </Typography>

          <Typography marginTop={3}>
            התחרות מבוצעת בין כיתות באותה שכבת גיל (לדוגמא כיתה משכבה ח מתמודדת
            מול כיתות ח אחרות בבית הספר שלה ובשאר בתי הספר בעיר - וכך בכל
            השכבות). בכל שכבה שלושת המקומות הראשונים הם המנצחים.
          </Typography>

          <Typography marginTop={3}>
            התחרות תתבצע גם בין בתי הספר – כאשר ציון בית ספר מסכם את סך הכוכבים
            שנצברו על ידי תלמידי בית הספר. גם בין בתי הספר שלושת הראשונים זוכים.
          </Typography>

          <Typography marginTop={3}>
            <strong>חישוב הציון הכיתתי </strong>
            וכיצד ניתן לשפר את הציון הכיתתי: כאשר התלמידים מתרגלים דיבור
            בסימולטור הם מקבלים כוכבים על כל משפט שתורגל בעברית דבורה (שלושה
            כוכבים לביצוע מצוין, שניים לביצוע טוב ואחד לביצוע שאפשר לשפר). הציון
            כיתתי מהווה את מספר הכוכבים שצברה הכיתה. ככל שהתלמידים יתרגלו יותר
            דיבור בעברית ויצברו יותר כוכבים – יעלו את הציון הכיתתי. גם תלמידים
            שמקבלים כוכב אחד על משפט יכולים להעלות את הציון הכיתתי על ידי תרגול
            רב יותר (וכך גם ישפרו את רמת העברית הדבורה שלהם). יש חשיבות רבה לכך
            שכל התלמידים בכיתה יתרגלו.
          </Typography>

          <Typography marginTop={3}>
            תרגול מהנה ומועיל ובהצלחה לכולם.
          </Typography>
        </Box>
      )} */}
    </Box>
  );
}
